import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import Icon from '../AppIcon';

const BookingTrigger = ({ variant = 'default', size = 'default', className = '', isFab = false }) => {
  const navigate = useNavigate();

  const handleBookingClick = () => {
    navigate('/smart-booking-form');
  };

  if (isFab) {
    return (
      <div className="fab-booking">
        <button
          onClick={handleBookingClick}
          className="fab-booking-button"
          aria-label="Book a taxi"
        >
          <Icon name="Calendar" size={24} />
        </button>
      </div>
    );
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleBookingClick}
      iconName="Calendar"
      iconPosition="left"
      className={`booking-trigger ${className}`}
    >
      Book Now
    </Button>
  );
};

export default BookingTrigger;